import React from 'react';
import { gql } from '@apollo/client';
import { Show, SimpleShowLayout, TextField, FunctionField } from 'react-admin';
import MoneyField from 'components/MoneyField';
import DateTimeField from 'components/DateTimeField';

const GeneratedRateShow = () => {
  return (
    <Show>
      <SimpleShowLayout>
        <TextField source="id" />
        <TextField label="Status" source="status" />
        <TextField label="Scope Type" source="scope_type" />
        <TextField label="Scope ID" source="scope_id" />
        <FunctionField label="Position" render={(record) => record?.position?.display_name || ''} />
        <FunctionField label="Specialty" render={(record) => record?.specialty?.label || ''} />
        <MoneyField label="Generated Rate" source="generated_rate_cents" blankIfNull />
        <MoneyField label="Current Rate" source="current_rate_cents" blankIfNull />
        <TextField label="Variance" source="variance_percent" />
        <DateTimeField label="Deadline" source="review_deadline" />
        <DateTimeField label="Created At" source="created_at" />
      </SimpleShowLayout>
    </Show>
  );
};

GeneratedRateShow.query = gql`
  query autoGeneratedRate($id: Int!) {
    autoGeneratedRate(id: $id) {
      id
      status
      review_deadline
      created_at
      generated_rate_cents
      current_rate_cents
      variance_percent
      scope_type
      scope_id
      position_id
      position {
        id
        display_name
      }
      specialty_id
      specialty {
        id
        label
      }
      last_approved {
        approved_at
        type
      }
      metrics_data {
        gsv
        fill_rate
        supply_level_category
        supply_utilization_category
        hours_to_fill_last_3_months
      }
    }
  }
`;

export default GeneratedRateShow;
